import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import Warning from '@material-ui/icons/Warning';

const SIZES = [
  'default',
  'large',
  'medium',
  'small',
];

const useStyles = buildUseStyles('WarningIcon', () => ({
  root: {},
}));

const WarningIcon = React.forwardRef(({
  className,
  size,
}, ref) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Icon
      ref={ref}
      className={classNames(className, classes.root)}
      fill={'orange'}
      icon={Warning}
      fontSize={size}
    />
  );
});

WarningIcon.defaultProps = {
  className: '',
  size: 'default',
};

WarningIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(SIZES),
};

export default WarningIcon;
